import { render, staticRenderFns } from "../../../components/shared/physicianSearch/BaseResult.html?vue&type=template&id=7b3eb1db&scoped=true&"
import script from "./SearchResult.vue?vue&type=script&lang=js&"
export * from "./SearchResult.vue?vue&type=script&lang=js&"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=7b3eb1db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3eb1db",
  null
  
)

component.options.__file = "SearchResult.vue"
export default component.exports